import { render, staticRenderFns } from "./modifypass.vue?vue&type=template&id=7926e13b&"
import script from "./modifypass.vue?vue&type=script&lang=js&"
export * from "./modifypass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports